import $ from "cash-dom";
import globals from "imports/globals";
import { gsapTrigger as WyPt } from "Utilities";

const layout = (function () {
    /**
     * Initialize Panning Image instances
     */
    $(document).ready(function () {
        if ($(".layout-panning-image").length) {
            if (globals.debug) console.log("layout-panning-image initialized");
            var panningImages = [];
            $(".layout-panning-image")
                .find(".keyframe")
                .each(function () {
                    var caption = $(this).parents(".layout-panning-image").find(".dynamic-caption-inner");
                    panningImages.push(
                        new WyPt({
                            element: $(this)[0],
                            offset: {
                                top: "top-top",
                                bottom: "bottom-bottom",
                            },
                            // pointMode: true,
                            // debug: true,
                            callback: {
                                enter: function (_el, _dir) {
                                    globals.refocusImage(_el);
                                    globals.replaceText(_el, caption);
                                },
                                leave: function (_el, _dir) {
                                    if (_el.previousElementSibling && _dir == "up") {
                                        globals.refocusImage(_el.previousElementSibling);
                                        globals.replaceText(_el.previousElementSibling, caption);
                                    }
                                },
                            },
                        })
                    );
                });

            /*
            $(".layout-panning-image").each(function () {
                new WyPt({
                    element: $(this)[0],
                    offset: {
                        top: "top-bottom",
                        bottom: "bottom-top",
                    },
                    callback: {
                        enter: function () {
                            if (!globals.isScrolling) $("html").addClass("scroll-snap-y");
                        },
                        leave: function () {
                            $("html").removeClass("scroll-snap-y");
                        },
                    },
                });
            });
            */
        }
    });
})();

export default layout;
